import axios from '../axios';
import { UPDATE_TEAM_ROLE_ACCESS_REG_BRANCH } from '../ApiUrl';

/**
 * PUT /UpdateTeamRoleAccessRegBranch
 * Updates TeamRoleAccess-RegBranch matched by branchName + team_user_id.
 *
 * @param {Object} payload — see API docs (routeAccess vs remove_routeAccess mutually exclusive, etc.)
 */
export const updateTeamRoleAccessRegBranchAPI = async (payload) => {
  try {
    const response = await axios.put(UPDATE_TEAM_ROLE_ACCESS_REG_BRANCH, payload);
    return response;
  } catch (error) {
    console.log('updateTeamRoleAccessRegBranchAPI catch', error);
    return { hasError: true, error };
  }
};
